import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from "vue";

interface Props {
    value: boolean,
    labelBefore?: string,
    labelAfter?: string,
    customClass?: string,
    id?: string | number,
    size?: 'large',
    disabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSwitch',
  props: {
    value: { type: Boolean },
    labelBefore: null,
    labelAfter: null,
    customClass: null,
    id: null,
    size: null,
    disabled: { type: Boolean }
  },
  emits: ['update:value'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    value: boolean,
    labelBefore?: string,
    labelAfter?: string,
    customClass?: string,
    id?: string | number,
    size?: 'large',
    disabled?: boolean,
}




const getId = computed<number | string>(() => {
    const instance = getCurrentInstance();
    const uniqueId = `switch-${instance?.uid || Math.random().toString(36).substring(2, 9)}`;

    return props.id ? props.id : uniqueId;
});

const getClasses = computed<string>(() => {
    const classes = {
        [props.customClass]: !!props.customClass,
        [`is-${props.size}`]: !!props.size,
        'is-disabled': props.disabled,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

return { __sfc: true,props, emits, getId, getClasses }
}

})